import useBottomSheetStore from 'stores/bottomSheetStore';
import { CloseOptions } from 'types/bottomsheet';

/**
 * BottomSheet를 컴포넌트 외부에서 제어할 수 있는 브리지 함수들
 * Vanilla JS 에서 사용
 */
const BottomSheetBridge = {
  /**
   * BottomSheet 열기
   */
  open: async (id: string, payload?: any) => {
    return useBottomSheetStore.getState().open(id, payload);
  },

  /**
   * BottomSheet 닫기
   */
  close: (id: string, options?: CloseOptions) => {
    useBottomSheetStore.getState().close(id, options);
  },

  /**
   * 뒤로가기 버튼 처리
   * 열린 BottomSheet가 있으면 닫고 true 반환, 없으면 false 반환
   */
  processBackButton: () => {
    const sheets = useBottomSheetStore.getState().sheets;
    const opened = Object.keys(sheets).filter((sheet) => sheets[sheet].status === 'opened' || sheets[sheet].status === 'processing');

    if (opened.length > 0) {
      const lastSheet = opened[opened.length - 1];
      if (lastSheet) {
        useBottomSheetStore.getState().close(lastSheet, { skipConfirm: false });
      }
      return true;
    }
    return false;
  },

  updateData: (id: string, data: Record<string, any>) => {
    useBottomSheetStore.getState().updateData(id, data);
  },

  /**
   * 특정 BottomSheet가 열려있는지 확인
   */
  isOpen: (id: string) => {
    const sheet = useBottomSheetStore.getState().sheets[id];
    return sheet?.status === 'opened' || sheet?.status === 'processing';
  },
};

export default BottomSheetBridge;
